import { IAPI } from '../createService'

const EXCLUDES = ['constructor'].concat(
  Object.getOwnPropertyNames(Object.getPrototypeOf({})),
)

export function filterKeysByType(
  obj: any,
  total: string[] = [],
  type = 'function',
): string[] {
  return Object.getOwnPropertyNames(obj).filter(key => {
    return (
      total.indexOf(key) === -1 &&
      EXCLUDES.indexOf(key) === -1 &&
      key.indexOf('_') !== 0 && // consider it's private
      obj.hasOwnProperty(key) &&
      typeof obj[key] === type
    )
  })
}

export function aggregateApisByType(obj: any, total: string[] = []): string[] {
  const keys: string[] = []
  while (obj !== null) {
    const arr = filterKeysByType(obj, total)
    keys.push(...arr)
    obj = Object.getPrototypeOf(obj)
  }
  return keys
}

// extracts lists of methods from each service object.
export default function extractApis(services: IAPI[]) {
  const apis = services.reduce((total: string[], service: IAPI) => {
    const obj =
      service.constructor === Object ? service : Object.getPrototypeOf(service)
    const keys = aggregateApisByType(obj, total)
    total.push(...keys)
    return total
  }, [])

  return apis
}
